function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: 50,
    height: 50,
    viewBox: "0 0 1.5 1.5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontSize: "1.92px",
      fill: "#000000",
      strokeWidth: 0.03999
    },
    x: 0.14322285,
    y: 1.4494152,
    id: "text5144"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan5142",
    style: {
      fontSize: "1.92px",
      strokeWidth: 0.03999
    },
    x: 0.14322285,
    y: 1.4494152
  }, "T")));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.228fca31a987ee08051e5e9b68b10743.svg";
export { ForwardRef as ReactComponent };